import React, { useState, useRef } from 'react'
import { getBEMCls } from '@/utils/classname'

import './search-input.scss'
import Iconfont from '../iconfont/iconfont'
import Tooltip from 'antd/es/tooltip'
import WordHighLight from '../word-highlight/word-highlight'
import { useClickAway } from 'ahooks'

interface SearchInputProps {
    onSearch?: (val: string) => void
    onDelete?: () => void
    onValueChange?: (val: string) => void
    searchList?: any[]
    searchKey?: string
    searchDom?: React.ReactNode
    isExpaned?: boolean
    isEnter?: boolean // 是否使用enter键触发搜索
    onItem?: (item: any) => void
}

const SearchInput: React.FC<SearchInputProps & React.InputHTMLAttributes<any>> = props => {
    const getCls = (el?: string, moder?: string) => getBEMCls('search-input', el, moder)
    const [isFocus, setIsFocus] = useState(false)
    const [value, setValue] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)
    const searchRef = useRef<HTMLDivElement>(null)

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13 && props.isEnter) {
            setVisible(true)
            props.onSearch && props.onSearch(value)
        }
    }

    const debounceRun = (e: string) => {
        props.onValueChange && props.onValueChange(e)
        setValue(e)
    }

    useClickAway(() => {
        setVisible(false)
        setIsFocus(false)
    }, searchRef)

    const soltContent = (
        <div className={getCls()} ref={searchRef}>
            <div
                onClick={() => {
                    setVisible(true)
                    props.onSearch && props.onSearch(value)
                }}
            >
                {props.searchDom}
            </div>
            <div data-expaned className={`${getCls('left')} ${isFocus ? getCls('focus') : ''}`}>
                <input
                    placeholder={props.placeholder}
                    data-expaned
                    className={`${getCls('left_ipt')} ${
                        props.isExpaned ? 'expaned' : getCls('scale', isFocus ? 'focus' : undefined)
                    }`}
                    onFocus={() => setIsFocus(true)}
                    onKeyDown={onKeyDown}
                    value={value}
                    onChange={e => {
                        debounceRun(e.currentTarget.value)
                    }}
                />
                {value.trim().length > 0 && (
                    <div
                        className={getCls('left_delete')}
                        onClick={() => {
                            setValue('')
                            props.onDelete && props.onDelete()
                        }}
                    >
                        <Iconfont name="icon3qingkong1-20" size={16}></Iconfont>
                    </div>
                )}
            </div>
            <div
                className={getCls('right')}
                onClick={() => {
                    setVisible(true)
                    props.onSearch && props.onSearch(value)
                }}
            >
                <i className={`${getCls('right', 'icon')} iconfont icon6sousuo999-20`} />
            </div>
        </div>
    )

    return props.searchList && props.searchList.length ? (
        <Tooltip
            placement="bottomLeft"
            visible={visible}
            title={() =>
                props.searchList && (
                    <div className={getCls('word-con')}>
                        {props.searchList.map(key => (
                            <div
                                className={getCls('word')}
                                key={key.id}
                                onClick={() => {
                                    setVisible(false)
                                    props.onItem && props.onItem(key)
                                }}
                            >
                                <WordHighLight word={key[props.searchKey || '']} keyword={value} />
                            </div>
                        ))}
                    </div>
                )
            }
        >
            {soltContent}
        </Tooltip>
    ) : (
        soltContent
    )
}

SearchInput.defaultProps = {
    isExpaned: true,
    searchKey: 'name',
    isEnter: true,
}

export default SearchInput
